/* AUTO GLASS ELITE SHIELD — TECH PRO interactions (static sections: no scroll reveal, no number count-up) */
(function(){
  var d=document;
  function init(){
    d.querySelectorAll('.svc-card,.hiw-card,.rev-card').forEach(function(c){
      c.addEventListener('mousemove',function(e){
        var r=c.getBoundingClientRect();
        c.style.setProperty('--mx',(e.clientX-r.left)+'px');
        c.style.setProperty('--my',(e.clientY-r.top)+'px');
      });
    });
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})();
